import React from "react";
import "../../styles/components/marketplace-shared.css";

const StatusBadge = ({ children, tone = "info", className = "" }) => (
  <span className={`marketplace-status-badge marketplace-status-badge--${tone} ${className}`.trim()}>
    {children}
  </span>
);

export default StatusBadge;


